class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.STORAGE_KEY = 'theme:recently-viewed-products';
  }

  connectedCallback() {
    this.render();
  }

  getProducts() {
    try {
      const products = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
      return Array.isArray(products) ? products : [];
    } catch (e) {
      return [];
    }
  }

  escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  formatMoney(cents) {
    const locale = this.dataset.locale || 'en-US';
    const currency = this.dataset.currency || 'USD';

    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol'
    }).format(cents / 100);

    return `${formatted} ${currency}`;
  }

  render() {
    const limit = Number(this.dataset.limit || 8);
    const grid = this.querySelector('.recently-viewed__grid');

    if (!grid) return;

    const products = this.getProducts()
      .filter(product => product && product.id && product.title && product.url)
      .slice(0, limit);

    if (!products.length) return;

    grid.innerHTML = products.map(product => `
      <a href="${product.url}" class="recently-viewed__card">
        ${
          product.image
            ? `<img
                class="recently-viewed__image"
                src="${product.image}"
                alt="${this.escapeHtml(product.title)}"
                loading="lazy"
              >`
            : ''
        }

        <div class="recently-viewed__title">
          ${this.escapeHtml(product.title)}
        </div>

        <div class="recently-viewed__price">
          ${this.formatMoney(product.price)}
        </div>
      </a>
    `).join('');

    this.style.display = 'block';
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
